import { render, staticRenderFns } from "./_Slider.vue?vue&type=template&id=af56cb70&"
import script from "./_Slider.vue?vue&type=script&lang=js&"
export * from "./_Slider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports